import { useEffect, useState } from 'react';
import { API } from '@unboared/react';

import { useGlobalPopup } from '~/components/design/popup/GlobalPopup';
// import { UnlimitedPopup } from '~/components/design/popup/UnlimitedPopup';
import { FreeTrial } from '~/components/design/popup/FreeTrial';

const MAX_GAMEPADS = 100;
const MAX_TIME = 1000 * 60 * 3; /* ms * s * min */

export function useLimitedAccess(clientID: string) {
    const [locked, setLocked] = useState(false);
    const { content, open, close } = useGlobalPopup();

    const limitedAccessComponent = <FreeTrial />;

    useEffect(() => {
        let unsub0 = () => {};
        if (clientID === 'demo') {
            unsub0 = API.onConnect(() => {
                if (API.getGamepadIDs().length > 0) {
                    setTimeout(() => {
                        open(limitedAccessComponent);
                        setLocked(true);
                    }, MAX_TIME);
                }
            });
        }
        return unsub0;
    }, [clientID]);

    useEffect(() => {
        let unsub1 = () => {};
        if (clientID === 'demo') {
            unsub1 = API.onConnect(() => {
                if (API.getGamepadIDs().length > MAX_GAMEPADS) {
                    open(limitedAccessComponent);
                }
            });
        }
        return unsub1;
    }, [clientID]);

    useEffect(() => {
        let unsub2 = () => {};
        if (clientID === 'demo') {
            unsub2 = API.onDisconnect(() => {
                if (API.getGamepadIDs().length <= MAX_GAMEPADS) {
                    close();
                }
            });
        }
        return unsub2;
    }, [clientID]);

    useEffect(() => {
        if (clientID === 'demo' && !content && (API.getGamepadIDs().length > MAX_GAMEPADS || locked)) {
            open(limitedAccessComponent);
        }
    }, [content, locked, clientID]);
}
